import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import Button from '@/Components/Button';
import { Tooltip } from '@/Components/Tooltip';
import type { ButtonProps } from '@/Components/Button/Button';
import { type forcedDomain } from '@/types';

type Props = ButtonProps & {
  href?: string;
  active?: boolean;
  iconColor?: string;
  className?: string;
  hideText?: boolean;
  text?: string;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
  onClick?: () => void;
  forceUrlDomain?: forcedDomain;
};

export default function NavLink({
  active = false,
  children,
  className,
  hideText = false,
  text,
  tooltipSide = 'top',
  ...rest
}: PropsWithChildren<Props>) {
  const buttonComponent = (
    <Button
      className={classNames(
        'bg-transparent text-brand-dark-100/40 outline-none hover:bg-brand-50 focus:ring-1 focus:ring-brand dark:text-brand-light-25 hover:dark:bg-brand-dark-50 hover:dark:text-brand-light-100 focus:dark:ring-brand-dark',
        {
          'bg-brand-50 text-brand-dark-100 dark:bg-brand-dark-50 dark:text-brand-light-100':
            active,
        },
        className
      )}
      {...rest}
    >
      <>
        {children}
        {text && !hideText && <span>{text}</span>}
      </>
    </Button>
  );

  return text && hideText ? (
    <Tooltip message={text} content={{ side: 'right', sideOffset: 0 }}>
      {buttonComponent}
    </Tooltip>
  ) : (
    buttonComponent
  );
}
